import gsap from 'gsap'

import BaseComponent from '@blocks/_BaseComponent'




/* GUIDE INTRO
---------------------------------------------------------------------------------------------------- */

export default class GuideBackground extends BaseComponent {

    constructor($el, namespace) {
        super('GuideBackground', $el, namespace)

        if (APP.Layout.isDesktop) {
            this.initTimeline()
        }

        this.on()
    }


    bindHandlers() {
        this.resizeHandler = () => { this.onResize() }
    }


    bindEvents() {
        this.$utils.doc.one('pageChangeEnd', () => { this.onPageChangeEnd() })

        this.addListeners(
            [this.$utils.doc, 'layoutChange', this.resizeHandler],
        )
    }




    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        const { isDesktop } = APP.Layout

        if (this.TLs && !isDesktop) {
            this.clearTimelines(true)
        } else if (!this.TLs && isDesktop) {
            this.initTimeline()
        }
    }


    onPageChangeEnd() {
        this.clearTimelines(true)
    }




    /* Init
    --------------------------------------------------------- */

    initTimeline() {
        this.TLs = []

        // BG Mover x translation
        this.TLs[0] = gsap.timeline({
            defaults: { ease: 'none' },
            scrollTrigger: {
                id: 'guideBackground',
                trigger: this.$el,
                start: 'top 50%',
                end: 'top 0%',
                scrub: 0.5,
            },
        })

        this.TLs[0].to(this.$refs.mover, { '--xOffset': 1 })


        // BG Star rotation when Detail is pinned
        this.TLs[1] = gsap.timeline({
            defaults: { ease: 'none' },
            scrollTrigger: {
                id: 'guideStar',
                trigger: this.$el,
                start: '+=250px',
                endTrigger: this.$el.closest('.js-scrollStage'),
                end: 'bottom top',
                scrub: 0.5,
            },
        })

        this.TLs[1].to(this.$refs.star, { '--rProgress': 1 })


        // Detail pinning
        this.TLs[2] = gsap.timeline({
            defaults: { force3D: true, ease: 'none' },
            scrollTrigger: {
                id: 'guideDetail',
                pin: true,
                pinSpacing: false,
                trigger: this.$refs.detail,
                start: 'center center',
                endTrigger: this.$el.closest('.js-scrollStage'),
                end: 'bottom bottom',
            },
        })
    }




    /* Actions
    --------------------------------------------------------- */

    clearTimelines(clearST) {
        if (!this.TLs) return

        this.TLs.forEach((tl) => {
            if (clearST) {
                tl.scrollTrigger.kill(true)
            }

            tl.kill(true)
            tl.clear()
        })

        this.TLs = null
    }

}



